import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1743.8579 0.0124561278L959.869211 783.876581 176.005086 0.0124561278 0 176.142104 783.739563 960.130789 0 1743.87035 176.005086 1920 959.869211 1136.26044 1743.8579 1920 1919.98754 1743.87035 1136.12342 960.130789 1919.98754 176.142104z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDiscussionXSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconDiscussionXSolid, _Component);

  var _super = _createSuper(IconDiscussionXSolid);

  function IconDiscussionXSolid() {
    _classCallCheck(this, IconDiscussionXSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconDiscussionXSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDiscussionX",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDiscussionXSolid.displayName = "IconDiscussionXSolid";
  return IconDiscussionXSolid;
}(Component);

IconDiscussionXSolid.glyphName = 'discussion-x';
IconDiscussionXSolid.variant = 'Solid';
IconDiscussionXSolid.deprecated = true;
IconDiscussionXSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDiscussionXSolid;
export { IconDiscussionXSolid };